import { css } from "@emotion/css";

import { brown } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export function createTaskStatusTogglerStyles({
  borderRadius,
  palette,
  typography,
  spacing,
}: Theme) {
  return {
    root: css({
      position: "fixed",
      left: 0,
      bottom: 0,
      height: 147,
      width: "100%",
      backgroundColor: palette.primary.light,
      borderTopLeftRadius: borderRadius.huge,
      borderTopRightRadius: borderRadius.huge,
      transition: "height 0.3s",
    }),
    done: css({
      height: 122,
    }),
    text: css({
      color: brown[600],
      marginTop: spacing(3),
      textAlign: "center",
      fontWeight: typography.fontWeight.semiBold,
      transition: "opacity 0.15s",
      transformOrigin: "top",
    }),
    tick: css({
      position: "absolute",
      top: "50%",
      left: spacing(3),
      transform: "translateY(-50%)",
    }),
    textInvisible: css({
      opacity: 0,
    }),
    button: css({
      position: "absolute",
      bottom: spacing(4),
      left: "50%",
      transform: "translateX(-50%)",
      width: 160,
      height: 50,
      border: `2px solid ${brown[600]}`,
      borderRadius: borderRadius.medium,
      textTransform: "uppercase",
      "&:disabled": {
        cursor: "not-allowed",
        backgroundColor: palette.primary.dark,
      },
    }),
  };
}
